import axios from 'axios';

export default function useLawMaker() {
  const getLawmakersList = async () => {
    let axiosT = axios.create({
      baseURL: `${process.env.REACT_APP_FEATURED_API}lawmakers/`,
      headers: {
        Authorization: `JWT ${localStorage.getItem('token')}`,
      },
    });

    return axiosT.get('')
      .then(async (res) => {
        return res.data.sort((a, b) => a.last.localeCompare(b.last) || a.first.localeCompare(b.first));
      }).catch((err) => {
        console.log(err);
      })
  };

  return {
    getLawmakersList
  }
}
